<template>
    <div>
        <div v-if="!editMode" :style="{ cursor: isAdmin ? 'grab' : 'default' }" class="d-flex justify-content-between align-items-center kanban-non-card">
            <h5 @click="openEdit(section.id)">
<!--                <b-icon v-if="isAdmin && !isOtherSection" icon="grip-vertical"></b-icon>-->
                <span :class="{ 'admin_editable': isAdmin }">{{ section.title }}</span>
                <span v-if="section.is_hidden_for_users" class="text-muted" v-b-tooltip.hover title="This section is only visible for admins.">
                    <b-icon icon="eye-slash" aria-hidden="true"></b-icon>
                </span>
                <span v-if="isOtherSection && isAdmin" v-b-tooltip.hover title="This is a space for posts without a section. Remove all posts from this section to hide it."><b-icon icon="question-circle-fill"></b-icon></span>
            </h5>

            <b-dropdown v-if="isAdmin" variant="outline" right size="sm" no-caret class="mb-2" toggle-class="column-menu-button">
                <template v-slot:button-content>
                    <b-icon icon="three-dots" aria-hidden="true"></b-icon>
                </template>
                <b-dropdown-item v-if="!isOtherSection" @click="openEdit(section.id)">Edit</b-dropdown-item>
                <b-dropdown-item @click="showModal">Add column after</b-dropdown-item>
                <template v-if="!isOtherSection">
                    <b-dropdown-item v-if="!section.is_hidden_for_users" @click="toggleVisibility">Hide from users</b-dropdown-item>
                    <b-dropdown-item v-else @click="toggleVisibility">Display to users</b-dropdown-item>
                    <b-dropdown-item @click="deleteSection">Delete</b-dropdown-item>
                </template>
            </b-dropdown>
        </div>
        <div v-else class="d-flex align-items-center">
            <input
                v-model="editedTitle"
                @keyup.enter="update"
                type="text"
                class="form-control"
            />
        </div>

        <AddSectionModal :is-modal-visible="isModalVisible" @hide="isModalVisible = false" :tab-id="section.tab_id" :after-section-id="section.id" @section-created="handleSectionCreated" />

    </div>
</template>

<script>
import AddSectionModal from './AddSectionModal.vue';

export default {
    components: {
        AddSectionModal
    },
    props: {
        section: {
            type: Object,
            required: true
        },
        isAdmin: {
            type: Boolean,
            required: true
        },
        canDelete: {
            type: Boolean,
            required: true
        },
        isOtherSection: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            editMode: false,
            editedTitle: '',
            addingSectionAfter: false,
            newSectionTitle: '',
            isModalVisible: false,
            creating: false,
        };
    },
    methods: {
        openEdit(id) {
            if(!this.isAdmin) return;

            // Trying to edit other section
            if(id === null) {
                alert("Renaming the 'Other' section is not allowed. Please create a new section by clicking the three dots. The 'Other' section will automatically disappear if it has no posts.");
                return;
            }

            this.editMode = true;
        },
        showModal() {
            this.isModalVisible = true;
        },
        resetModal() {
            this.isModalVisible = false;
            this.newSectionTitle = '';
            this.creating = false;
        },
        handleSectionCreated(newSection) {
            // Refresh your section list or handle the new section
            this.$emit('section-created', newSection, this.section.id);
        },
        toggleVisibility() {
            this.section.is_hidden_for_users = !this.section.is_hidden_for_users
            this.update()
        },
        update() {
            if (!this.editedTitle.trim()) {
                alert('The title must be given.');
                return;
            }
            this.$http.patch(`/http_api/sections/${this.section.id}`, { title: this.editedTitle, is_hidden_for_users: this.section.is_hidden_for_users })
                .then(response => {
                    this.$emit('update-section', response.data.data);
                    this.section.title = this.editedTitle
                    this.editMode = false;
                })
                .catch(error => {
                    console.error(error);
                    alert('Error updating section. Please try again.');
                });
        },
        deleteSection() {
            if(!this.canDelete) {
                alert('You can only delete sections without posts.');
                return;
            }

            const confirmDelete = confirm('Are you sure you want to delete this section?');
            if (confirmDelete) {
                this.$http.delete(`/http_api/sections/${this.section.id}`)
                    .then(() => {
                        this.$emit('delete-section', this.section.id);
                    })
                    .catch(error => {
                        console.error(error);
                        alert('Error deleting section. Please try again.');
                    });
            }
        }
    },
    watch: {
        section: {
            handler(newSection) {
                this.editedTitle = newSection.title;
            },
            immediate: true
        }
    }
};
</script>
